export var TileMixin = function TileMixin(chart, props) {
  var chartTitle = props.chartTitle;
  if (!chartTitle === '') throw new Error('Mandatory property chartTitle missing');
  return chart;
};